import { ChangeDetectionStrategy, Component, Input, Signal, computed } from '@angular/core';

import { OddsDisplayFormat } from '@frontend/sports/types/models/user-settings';
import { Store } from '@ngrx/store';
import { BehaviorSubject } from 'rxjs';

import { BetslipType } from '../../../../core/betslip-type';
import { BETSLIP_TYPE_PROVIDER } from '../../../../digital/services/betslip-type-provider.service';
import { RemoveButtonStyle } from '../../../picks/components/digital/pick-remove-button/remove-button-style';
import { BetBuilderPick } from '../../models';
import { selectBetBuilderPicks } from '../../selectors';

@Component({
    selector: 'bs-linear-bet-builder',
    templateUrl: './linear-bet-builder.component.html',
    styleUrls: ['./linear-bet-builder.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [{ provide: BETSLIP_TYPE_PROVIDER, useValue: new BehaviorSubject(BetslipType.BetBuilder).asObservable() }],
    standalone: false,
})
export class LinearBetBuilderComponent {
    @Input() oddsDisplayFormat: OddsDisplayFormat;
    @Input() removeButtonStyle: RemoveButtonStyle;

    readonly picks: Signal<BetBuilderPick[]>;
    readonly showModule: Signal<boolean>;
    readonly betCount: Signal<number>;

    readonly betslipType = BetslipType.BetBuilder;

    constructor(store: Store) {
        this.picks = store.selectSignal(selectBetBuilderPicks);

        this.betCount = computed(() => this.picks().length);
        this.showModule = computed(() => this.betCount() > 0);
    }
}
